module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-nav-layer-picker"
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Active Layer")]), _vm._v(" "), _c('md-menu', {
    ref: "layerMenu",
    attrs: {
      "md-size": "6"
    }
  }, [(_vm.currentLayer) ? _c('md-button', {
    staticClass: "pick-current-layer",
    style: ({
      backgroundColor: _vm.currentLayer.color
    }),
    attrs: {
      "md-menu-trigger": ""
    }
  }) : _c('md-button', {
    staticClass: "blank-current-layer",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Please choose an active layer.")])], 1), _vm._v(" "), (_vm.currentLayer) ? _c('span', {
    staticClass: "current-layer-name"
  }, [_vm._v(_vm._s(_vm.currentLayer.title))]) : _c('span', {
    staticClass: "current-layer-name"
  }, [_vm._v("Select an active layer")]), _vm._v(" "), _c('md-menu-content', _vm._l((_vm.layers), function(layer) {
    return _c('md-menu-item', {
      key: layer.id,
      on: {
        "selected": function($event) {
          _vm.selectLayer(layer)
        }
      }
    }, [_c('span', {
      staticClass: "ql-nav-layer-picker-item",
      style: (_vm.style(layer))
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-nav-layer-picker-option"
    }, [_vm._v(_vm._s(layer.title))])])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0d3f37","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/layers/layer-picker.vue
// module id = 640
// module chunks = 2